import { render, staticRenderFns } from "./ProjectTemplate6.vue?vue&type=template&id=228d240c&scoped=true"
import script from "./ProjectTemplate6.vue?vue&type=script&lang=js"
export * from "./ProjectTemplate6.vue?vue&type=script&lang=js"
import style0 from "./ProjectTemplate6.vue?vue&type=style&index=0&id=228d240c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228d240c",
  null
  
)

export default component.exports